import SuccessContainer from './SuccessContainer';

export default SuccessContainer;



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/ConfirmationPage/components/Success/index.js